import { Injectable, OnInit } from '@angular/core';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { RadiologyEhrData } from '../@core/interfaces/ehr/radiology-ehr';
import { DateService } from '../@theme/components/common/service/date.service';
import { environment } from '../../environments/environment';
import { PrinterSettings, PrinterSettingsData } from '../@core/interfaces/masters/printersettings';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';
import { PrintServiceService } from '../@theme/components/common/service/print-service.service';
import { DatePipe } from '@angular/common';
import { LabResultData } from '../@core/interfaces/lab/lab-result-detail';

@Injectable({
  providedIn: 'root'
})
export class PdfToBlobService{
  pdfcontent: Blob;
  regId: any;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  visitId: any;
  psDetails:PrinterSettings;
  protected readonly unsubscribe$ = new Subject<void>();
  resourceType: string;
  admissionId: any;
  labWorkOrderId: any;

  get apiUrl(): string { return environment.apiUrl; }

  constructor(private radiologySrvc: RadiologyEhrData,private datePipe: DatePipe,public datService: DateService,public PrintServiceService: PrintServiceService,private psSrvc:PrinterSettingsData)  {
   }
 
  async loadPSF()
  {
    // call api load printer settings
   await this.psSrvc.list(this.tenantId +"/"+this.branchId+ "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var ps=data.filter(ps=>ps.pageSetupFor=="Lab Result Entry")
      // set printer settings data
      if(ps.length>0){
        this.psDetails=ps[0];
          this.psDetails=this.PrintServiceService.onSetPsData(this.psDetails);
      }else{
          this.psDetails=this.PrintServiceService.onGetPrinterSettings();
      }
      }, (error) => {
      }, () => {
      });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async downloadPDFForHims(data1,patientName,regId,comp,psDetails,fileName,category,page,type:'Mail'|'Whatsapp'|'Qr-Code',event?) {
    if(!!event && type==='Mail' || type==='Whatsapp'){
      event.target.disabled=true;
    }
    if(type==='Mail' || type==='Whatsapp'){
      comp.loadPer = 30;
      comp.showPer = true;
    }
    
    try{
      html2canvas(data1).then(canvas => {
        // Calculate suitable page size
        psDetails.orientation = "Portrait";
        psDetails.paperSize = "A4";
        let pdf = new jspdf(psDetails.orientation === "Portrait" ? 'p' : 'l', 'cm', (psDetails.paperSize).toLowerCase());
  
        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();
  
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = width; // Use the full page width
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
        let position = 0;
        const pageHeight = pdf.internal.pageSize.getHeight();
  
        while (position < imgHeight) {
            // Add a new page if content doesn't fit
            if (position !== 0) {
                pdf.addPage();
            }
  
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, Math.min(pageHeight, imgHeight - position));
            position += pageHeight;
        }
        var pageCount = pdf.internal.pages.length;
        if (pageCount > 2) {
          var pageToDeleteIndex = pageCount - 1; // Index of the last page
          pdf.deletePage(pageToDeleteIndex);
        }
        var filename = !!patientName ? patientName.replace(/\s/g, '') + fileName + ".pdf" : '';
        this.pdfcontent = pdf.output('blob');
        if(type==='Mail' || type==='Whatsapp'){
          return this.callAtchForHims(this.pdfcontent, filename,comp,type,category,page,regId,event);
        }
        else if(type==='Qr-Code'){
          return this.callAtchForHims(this.pdfcontent, filename,comp,type,category,page,regId);
        }
        
    });
    }
    catch(e){
      if(type==='Qr-Code'){
        comp.spinner.hide()
      }
    }
    
  }
  
   
  callAtchForHims(data,filename,comp,type,category,page,regId,event?): void{
    if(type==='Mail' || type==='Whatsapp'){
        comp.loadPer = 80;
    }
    const file = new File([data], filename, { type: 'application/pdf' });
    const formData: FormData = new FormData();
    formData.append('fileKey', file,file.name);
  
    let postData= {
      regId: regId,
      tenantId: this.tenantId,
      branchId: this.branchId,
      containerName: this.tenantId,
      fileLocation: `${this.tenantId}/${this.branchId}/${regId}/${page}/${file.name}`,
      fileName: file.name,
      category:category,//
      doneDate: this.datService.currentDate(),
      doneBy:localStorage.getItem('userName'),
      fileAddedBy: "system",
      notes: null,//
      tagType: "none",
      fileAddedFrom: page,//
      isEdit:true,
      isCreate:true,
      WhatsappSentStatus:"Y",
      WhatsappSentDateTime:new Date()
    }
    
    for (const prop in postData) {
      if (!postData.hasOwnProperty(prop)) { continue; }
      formData.append(prop , postData[prop]);
    }

    if(type==='Qr-Code'){
      postData.WhatsappSentStatus='N'
    }
   
    this.radiologySrvc.create(`${this.apiUrl}/AtchDet/${this.tenantId}/${this.branchId}/addImageDetail`,formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(type==='Mail' || type==='Whatsapp'){
      comp.loadPer = 100;   
      comp.showPer = false; 
      comp.sendMail(data);
      }
      else if(type==='Qr-Code'){
        comp.blobUrl(data?.uri)
      }
    
    }, (error) => {
      if(type==='Mail' || type==='Whatsapp' && !!event){
      comp.showPer = false; 
      event.target.disabled=false;
      }
      else if(type==='Qr-Code'){
        comp.spinner.hide()
      }
      
    }, () => {
      if(type==='Mail' || type==='Whatsapp' && !!event){
        event.target.disabled=false;
      }
      else if(type==='Qr-Code'){
        comp.spinner.hide()
      }
    });
  }

  async downloadPDF(data2,visitId,resourceType,regId,admissionId,labWorkOrderId) {
    await this.loadPSF();
    this.visitId=visitId;
    this.resourceType=resourceType;
    this.regId=regId;
    this.admissionId=admissionId;
    this.labWorkOrderId=labWorkOrderId;
    html2canvas(data2).then(canvas => {
        this.psDetails.orientation = "Portrait";
        this.psDetails.paperSize = "A4";
        let pdf = new jspdf(this.psDetails.orientation === "Portrait" ? 'p' : 'l', 'cm', (this.psDetails.paperSize).toLowerCase());
        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = width; // Use the full page width
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let position = 0;
        const pageHeight = pdf.internal.pageSize.getHeight();
        while (position < imgHeight) {
            // Add a new page if content doesn't fit
            if (position !== 0) {
                pdf.addPage();
            }
  
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, Math.min(pageHeight, imgHeight - position));
            position += pageHeight;
        }
        var pageCount = pdf.internal.pages.length;
        if (pageCount > 2) {
          var pageToDeleteIndex = pageCount - 1; // Index of the last page
          pdf.deletePage(pageToDeleteIndex);
        }
        let filename="";
        if(this.resourceType==="Immunization"){
           filename = "Immunization_Report_For_Visit_Id_"+this.visitId+ ".pdf";
        }else if(this.resourceType==="Prescription"){
          filename = "Prescription_Report_For_Visit_Id_"+this.visitId+ ".pdf";
        }else if(this.resourceType==="DischargeSummary"){
          filename = "Discharge_summary_Report_For_Admission_Id_"+this.admissionId+ ".pdf";
        }else if(this.resourceType==="Lab"){
          filename = "Diagnostic_Report_For_Work_Order_Id_"+this.labWorkOrderId+ ".pdf";
        }
        this.pdfcontent = pdf.output('blob');
        data2.style.display="none";
        this.callAtch(this.pdfcontent, filename);
    });
  }
   
  callAtch(data,filename): void{
    const file = new File([data], filename, { type: 'application/pdf' });  
    const formData: FormData = new FormData();
    formData.append('fileKey', file,file.name);
  
    let postData = {
      regId: this.regId,
      tenantId: this.tenantId,
      branchId: this.branchId,
      containerName: this.tenantId,
      fileLocation: `${this.tenantId}/${this.branchId}/${this.regId}/${this.datService.newDate(this.datePipe.transform(new Date(),'mediumDate'))}/${file.name}`,
      fileName: file.name,
      category: this.resourceType,//
      doneDate: this.datService.currentDate(),
      doneBy: "abha",
      fileAddedBy: "system",
      notes: null,//
      tagType: "none",
      fileAddedFrom:"ABHAAtch",//
      isEdit:true,
      isCreate:true,
      WhatsappSentStatus:"N",
      WhatsappSentDateTime:new Date(),
      RegId: this.regId,
      VisitId:this.visitId,
      AdmissionId : this.admissionId,
      WorkOrderId : this.labWorkOrderId
    }
    
    for (const prop in postData) {
      if (!postData.hasOwnProperty(prop)) { continue; }
      formData.append(prop , postData[prop]);
    }
  
    this.radiologySrvc.create(`${this.apiUrl}/AtchDet/${this.tenantId}/${this.branchId}/atch`,formData).pipe(takeUntil(this.unsubscribe$)).subscribe((datam: any) => {
    }, (error) => {
    }, () => {
      this.resourceType=null;
      this.admissionId=null;
      this.labWorkOrderId=null;
      this.visitId=null;
      this.regId=null;
      this.pdfcontent=null;
    });
  }
}
